import {SortEvent, TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {Injectable, QueryList} from '@angular/core';
import { ELASTIC_SEARCH_SORT_ORDER } from '@models/elastic-search/request/elastic-search-sort-order.enum';
import { ElasticSearchSortValue } from '@models/elastic-search/request/elastic-search-sort-value';

@Injectable({
  providedIn: 'root'
})
export class TableHeaderSortableService {

  public initHeaders(sortableHeaders: QueryList<TableHeaderSortableDirective>, column: string, direction: string):
      QueryList<TableHeaderSortableDirective> {
    sortableHeaders.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }else{
        header.direction = direction === 'asc' ? 'asc' : 'desc';
      }
    });
    return sortableHeaders;
  }

  public resetHeaders(sortableHeaders: QueryList<TableHeaderSortableDirective>, column: string):
    QueryList<TableHeaderSortableDirective> {
    sortableHeaders.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    return sortableHeaders;
  }

  public sortItems<T>(items: T[], column: string, direction: string): T[] {
    if (items === null || items === undefined || items.length === 0) {
      return items;
    }

    if (direction === '' || column === '') {
      return items;
    }
    const dotIndex = column.indexOf('.');
    if (dotIndex < 0) {
      return items.sort((i1: T, i2: T) => {
        const res = this.compare(i1[column], i2[column]);
        return direction === 'asc' ? res : -res;
      });
    } else {
      const primaryProperty = column.substr(0, dotIndex);
      const secondaryProperty = column.substr(dotIndex + 1, column.length);
      return items.sort((i1: T, i2: T) => {
        const res = this.compare(i1[primaryProperty][secondaryProperty], i2[primaryProperty][secondaryProperty]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  public sortItemsByValue<T>(items: T[], valueSelector: (item: T) => unknown, direction: string): T[] {
    if (items === null || items === undefined || items.length === 0 || direction === '') {
      return items;
    }

    return [...items].sort((item1, item2) => {
      const result = this.compare(valueSelector(item1), valueSelector(item2));
      return direction === 'asc' ? result : -result;
    });
  }

  public getSortValue({ column, direction }: SortEvent): ElasticSearchSortValue {
    let sortOrder: ELASTIC_SEARCH_SORT_ORDER;
    if (direction === ELASTIC_SEARCH_SORT_ORDER.ASC.toLowerCase()) {
      sortOrder = ELASTIC_SEARCH_SORT_ORDER.ASC;
    } else if (direction === ELASTIC_SEARCH_SORT_ORDER.DESC.toLowerCase()) {
      sortOrder = ELASTIC_SEARCH_SORT_ORDER.DESC;
    } else {
      sortOrder = ELASTIC_SEARCH_SORT_ORDER.NONE;
    }
    return new ElasticSearchSortValue(column, sortOrder);
  }

  private compare(v1: unknown, v2: unknown): number {
    const normalizedV1 = this.normalize(v1);
    const normalizedV2 = this.normalize(v2);
    if (normalizedV1 < normalizedV2) {
      return -1;
    } else if (normalizedV1 > normalizedV2) {
      return 1;
    } else {
      return 0;
    }

  }

  private normalize(value: unknown): number | string {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = String(value).trim();
    if (stringValue === '') {
      return '';
    }

    const numericValue = Number(stringValue);
    if (!Number.isNaN(numericValue)) {
      return numericValue;
    }

    return stringValue.toLowerCase();
  }
}
